export class RequestWaterSamplingContact {
    contactId: number;
    fullName: string;
    phone: string;
    email: string;
}